import { useState } from "react";
import { Button, Card } from "@insights/ui";
import { useParams } from "react-router";
import { authClient } from "../../../api";
import { Loading, PageHeader } from "../../../shared/components";
import { AppShell } from "../../../shared/layout";
import { useInvitation } from "../hooks/useInvitation";

export function InvitationPage() {
  const { id } = useParams();
  const session = authClient.useSession();
  const [error, setError] = useState("");
  const invitation = useInvitation(id);

  async function accept() {
    const result = await (authClient.organization as any).acceptInvitation({
      invitationId: id,
    });
    if (result.error) {
      setError(result.error.message);
      return;
    }
    const workspaceId =
      result.data?.member?.organizationId ??
      result.data?.invitation?.organizationId;
    location.href = workspaceId ? `/w/${workspaceId}/builds` : "/";
  }

  async function switchAccount() {
    await authClient.signOut();
    location.href = `/invitations/${id}`;
  }

  if (invitation.isLoading) {
    return (
      <AppShell>
        <Loading />
      </AppShell>
    );
  }

  if (invitation.isError) {
    return (
      <AppShell>
        <PageHeader
          eyebrow="Workspace invitation"
          title="Invitation unavailable"
        />
        <Card className="form-card">
          <p>This invitation is invalid, expired, or no longer pending.</p>
        </Card>
      </AppShell>
    );
  }

  if (!invitation.data!.matchesRecipient) {
    return (
      <AppShell>
        <PageHeader
          eyebrow="Workspace invitation"
          title="Use the invited account"
        />
        <Card className="form-card">
          <p>
            This invitation cannot be accepted while signed in as{" "}
            <strong>{session.data?.user.email}</strong>. Sign in with{" "}
            <strong>{invitation.data!.recipientEmail}</strong>, the email
            address that received the invitation.
          </p>
          <Button onClick={switchAccount}>Switch account</Button>
        </Card>
      </AppShell>
    );
  }
  return (
    <AppShell>
      <PageHeader
        eyebrow="Workspace invitation"
        title={`Join ${invitation.data!.organizationName}`}
      />
      <Card className="form-card">
        <p>
          Accept this invitation to join as{" "}
          <strong>{invitation.data!.role}</strong>.
        </p>
        {error && <p className="error">{error}</p>}
        <Button onClick={accept}>Accept invitation</Button>
      </Card>
    </AppShell>
  );
}
